<template>
  <div>
    <!-- Loading historic timesheet date multiselect -->
    <loadingCube v-if="!loaded" :loadingMessage="'HISTORIC TIMESHEETS'"></loadingCube>
    <!-- Multiselect form - select date for historic timesheet review -->
    <div v-else-if="loaded" class="row" id="historic_ts_multiselect_form">

      <div class="col-12">
        <div class="row" v-if="timesheets !== null">
          <div class="col-12">
            <b-card :header="'Current (Un-Submitted) Timesheet for period Ending: ' + format_selected_period(this.timesheet_period.for_work_end_week_date)" header-tag="h4"
                    body-class="mb-3 record_card_body">
              <div class="row ts_view_btns">
                <div class="col-lg-3 form-group">
                  <button class="btn orcaBtn sm-btn grey_bg" :class="{activeBtn: selected_btn.per_worker_day}" data-toggle="tooltip"
                          @click="select_per_worker_day" title="View Per Worker">Per Worker (per Day)
                  </button>
                </div>
                <div class="col-lg-3 form-group">
                  <button class="btn orcaBtn sm-btn grey_bg" :class="{activeBtn: selected_btn.per_worker_loc}" data-toggle="tooltip"
                          @click="select_per_worker_loc" title="View Per Worker">Per Worker (per Location)
                  </button>
                </div>
                <div class="col-lg-3 form-group">
                  <button class="btn orcaBtn sm-btn grey_bg" :class="{activeBtn: selected_btn.per_location}" data-toggle="tooltip"
                          @click="select_per_location" title="Per Location">View Per Location
                  </button>
                </div>
                <div class="col-lg-3 form-group">
                  <button class="btn orcaBtn sm-btn grey_bg" :class="{activeBtn: selected_btn.works_completed}" data-toggle="tooltip"
                          @click="select_works_completed" title="View Works Completed Info">Works Completed Info
                  </button>
                </div>
                <div class="col-12">
                  <hr class="mt-1 mb-2">
                </div>
                <div class="col-12" v-if="selected_btn.per_worker_day">
                  <div class="row">
                    <div class="col-10 offset-1 form-group">
                      <button class="w-100 orcaBtn" :disabled="btn_download_worker_per_day" @click.prevent="download_worker_per_day"
                              :class="[btn_download_worker_per_day ? 'disabled' : '']">
                        <span v-if="btn_download_worker_per_day" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>DOWNLOADING EXCEL COPY - PER WORKER (PER DAY) ...</span>
                        <span v-else>DOWNLOAD EXCEL COPY - PER WORKER (PER DAY)</span>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive mb-3" id="historic_per_worker_day_table">
                    <table class="table table-striped table-sm">
                      <thead>
                      <tr>
                        <th scope="col" class="firstName">Name</th>
                        <th scope="col" class="jobTitle">Job Title</th>
                        <th scope="col" class="payRate">Pay/Rate Type</th>
                        <th scope="col" class="payRate">Pay Rate</th>
                        <th scope="col" class="days" v-for="d in week">
                          <div><span>{{ d }}</span></div>
                        </th>
                        <th scope="col" class="totalHours">Total Units</th>
                        <th scope="col" class="totalHours">Total<br><span style="font-size: 0.6rem;">Before additions & deductions</span></th>
                        <th scope="col" class="additionsDesc text-center" colspan="2">Pre-Tax Addition/Description</th>
                        <th scope="col" class="additionsDesc text-center" colspan="2">Post-Tax Addition/Description</th>
                        <th scope="col" class="deductionsDesc text-center" colspan="2">Pre-Tax Deduction/Description</th>
                        <th scope="col" class="deductionsDesc text-center" colspan="2">Post-Tax Deduction/Description</th>
                        <th scope="col" class="totalHours">Invoice Total</th>
                      </tr>
                      </thead>
                      <tbody v-for="w in per_worker_day" class="loc_body">
                      <tr class="header" @click="test($event)">
                        <td class="firstName">
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.first_name }} {{ w.surname }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data" v-if="w.job_title !== false">{{ w.job_title }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data" v-if="w.rate_type !== false && w.pay_type !== false">{{ w.rate_type }}/{{ w.pay_type }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data" v-if="w.pay_rate !== false">{{ w.pay_rate | currency }}</div>
                          </div>
                        </td>
                        <td v-for="(d, i) in week">
                          <div class="td_data_outer">
                            <div class="td_data text-center">
                              {{ parseFloat(calc_worker_day_total(w, i)).toFixed(2) }}<br>{{ calc_worker_day_price_total(w, i) | currency }}
                              <br>
                              {{ get_worker_absence(w, i) ? get_worker_absence(w, i) : '' }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ parseFloat(calc_worker_total_units(w)).toFixed(2) }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_b4_add_ded(w) | currency }}</div>
                          </div>
                        </td>

                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_pre_add(w) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_post_add(w) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_pre_ded(w) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_post_ded(w) | currency }}</div>
                          </div>
                        </td>

                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_worker_total_invoice(w) | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      <tr class="worker_row" v-for="(loc, k) in w"
                          v-if="k !== 'worker_id' &&k !== 'first_name' && k !== 'surname' && k !== 'internal_finance_ref'
                          && k !== 'job_title' && k !== 'pay_type' && k !== 'rate_type' && k !== 'pay_rate'">
                        <td class="firstName">
                          <div class="td_data_outer">
                            <div class="td_data">{{ loc.location }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ loc.job_title }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ loc.rate_type }}/{{ loc.pay_type }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ loc.pay_rate | currency }}</div>
                          </div>
                        </td>
                        <td v-for="dayPay in loc.timesheet_pay">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ parseFloat(dayPay.price).toFixed(2) }}<br>{{ calc_worker_day_price(dayPay.price, loc.pay_rate) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ loc.total_units }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ loc.total_before_additions_deductions | currency }}</div>
                          </div>
                        </td>

                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center" v-if="calc_loc_pre_add(loc.addition_pre_tax) > 0">{{ calc_loc_pre_add(loc.addition_pre_tax) | currency }}</div>
                            <div class="td_data text-center" v-else>-</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left">
                              <span v-for="(v,i) in loc.addition_pre_tax">
                                {{ v.amount | currency }} ({{ v.add_ded_desc.value }})<br>
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center" v-if="calc_loc_post_add(loc.addition_post_tax) > 0">{{ calc_loc_post_add(loc.addition_post_tax) | currency }}</div>
                            <div class="td_data text-center" v-else>-</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left">
                              <span v-for="(v,i) in loc.addition_post_tax">
                                {{ v.amount | currency }} ({{ v.add_ded_desc.value }})<br>
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center" v-if="calc_loc_pre_ded(loc.deduction_pre_tax) > 0">{{ calc_loc_pre_ded(loc.deduction_pre_tax) | currency }}</div>
                            <div class="td_data text-center" v-else>-</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left">
                              <span v-for="(v,i) in loc.deduction_pre_tax">
                                {{ v.amount | currency }} ({{ v.add_ded_desc.value }})<br>
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center" v-if="calc_loc_post_ded(loc.deduction_post_tax) > 0">{{ calc_loc_post_ded(loc.deduction_post_tax) | currency }}</div>
                            <div class="td_data text-center" v-else>-</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left">
                              <span v-for="(v,i) in loc.deduction_post_tax">
                                {{ v.amount | currency }} ({{ v.add_ded_desc.value }})<br>
                              </span>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ loc.invoice_total | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td class="running_totals">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">TOTALS</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>
                        <td v-for="(d, i) in week">
                          <div class="td_data_outer">
                            <div class="td_data text-center font-weight-bold">{{ parseFloat(calc_totals_worker_day(i)).toFixed(2) }}<br>{{
                                calc_totals_worker_day_price(i) |
                                    currency
                              }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ parseFloat(calc_totals_worker_total_units()).toFixed(2) }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_totals_worker_total_b4_add_ded() | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">
                              {{ calc_totals_worker_pre_add() | currency }}
                            </div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">
                              {{ calc_totals_worker_post_add() | currency }}
                            </div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">
                              {{ calc_totals_worker_pre_ded() | currency }}
                            </div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">
                              {{ calc_totals_worker_post_ded() | currency }}
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_totals_worker_total_invoice() | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="col-12" v-if="selected_btn.per_worker_loc">
                  <div class="row">
                    <div class="col-10 offset-1 form-group">
                      <button class="w-100 orcaBtn" :disabled="btn_download_worker_per_location" @click.prevent="download_per_worker_location"
                              :class="[btn_download_worker_per_location ? 'disabled' : '']">
                        <span v-if="btn_download_worker_per_location" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>DOWNLOADING EXCEL COPY - PER WORKER (PER LOCATION) ..
                          .</span>
                        <span v-else>DOWNLOAD EXCEL COPY - PER WORKER (PER LOCATION)</span>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive mb-3" id="historic_per_worker_loc_table">
                    <table class="table table-striped table-sm">
                      <thead>
                      <tr>
                        <th scope="col" class="firstName">Name</th>
                        <th scope="col" style="min-width:150px;">Job Title</th>
                        <th scope="col" class="payRate">Pay/Rate Type</th>
                        <th scope="col" class="payRate">Pay Rate</th>
                        <th scope="col" class="preview_sites" :style="'z-index: ' + zindexcalc(i)" v-for="(o, j, i) in timesheets.locations">
                          <div><span>{{ o[0].job_address_full }}</span></div>
                        </th>
                        <th scope="col" class="add_ded_total_columns">Pre Tax Addition</th>
                        <th scope="col" class="add_ded_total_columns">Post Tax Addition</th>
                        <th scope="col" class="add_ded_total_columns">Pre Tax Deduction</th>
                        <th scope="col" class="add_ded_total_columns">Post Tax Deduction</th>
                        <th scope="col" class="add_ded_total_columns">Total</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="w in per_worker_loc">
                        <td class="firstName">
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.first_name }} {{ w.surname }}</div>
                          </div>
                        </td>

                        <td class="">
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.job_title }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.rate_type }}/{{ w.pay_type }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.pay_rate | currency }}</div>
                          </div>
                        </td>

                        <td v-for="(j, loc, er) in timesheets.locations" class="preview_site_totals">
                          <div class="td_data_outer">
                            <div class="td_data">
                              {{ get_worker_site_total(w, loc) | currency }}
                            </div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_pre_tax_addition(w) | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_post_tax_addition(w) | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_pre_tax_deduction(w) | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_worker_post_tax_deduction(w) | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data">
                              {{ get_worker_invoice_total(w) | currency }}
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td class="running_totals">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">TOTALS</div>
                          </div>
                        </td>

                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold"></div>
                          </div>
                        </td>

                        <td v-for="(j, loc, er) in timesheets.locations" class="preview_site_totals">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_site_totals(loc) | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_pre_tax_addition() | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_post_tax_addition() | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_pre_tax_deduction() | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_post_tax_deduction() | currency }}</div>
                          </div>
                        </td>
                        <td class="add_ded_total_columns">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ calc_total_invoice_total() | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="col-12" v-if="selected_btn.per_location">
                  <div class="row">
                    <div class="col-10 offset-1 form-group">
                      <button class="w-100 orcaBtn" :disabled="btn_download_per_location" @click.prevent="download_per_location"
                              :class="[btn_download_per_location ? 'disabled' : '']">
                        <span v-if="btn_download_per_location" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>DOWNLOADING EXCEL COPY - PER LOCATION ..
                          .</span>
                        <span v-else>DOWNLOAD EXCEL COPY - PER LOCATION</span>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive mb-3" id="historic_per_location_table">
                    <table class="table table-striped table-sm">
                      <thead>
                      <tr>
                        <th scope="col" class="firstName">Name</th>
                        <th scope="col" class="jobTitle">Job Title</th>
                        <th scope="col" class="payRate">Pay/Rate Type</th>
                        <th scope="col" class="payRate">Pay Rate</th>
                        <th scope="col" class="days" v-for="d in week">
                          <div><span>{{ d }}</span></div>
                        </th>
                        <th scope="col" class="totalHours">Total Units</th>
                        <th scope="col" class="totalHours">Total<br><span style="font-size: 0.6rem;">Before additions & deductions</span></th>
                        <th scope="col" class="additionsDesc text-center" colspan="2">Pre-Tax Addition/Description</th>
                        <th scope="col" class="additionsDesc text-center" colspan="2">Post-Tax Addition/Description</th>
                        <th scope="col" class="deductionsDesc text-center" colspan="2">Pre-Tax Deduction/Description</th>
                        <th scope="col" class="deductionsDesc text-center" colspan="2">Post-Tax Deduction/Description</th>
                        <th scope="col" class="totalHours">Invoice Total</th>
                      </tr>
                      </thead>
                      <tbody v-for="(v, loc, i) in timesheets.locations" class="loc_body">
                      <tr class="header" @click="test($event)">
                        <td colspan="3" class="loc_location">
                          <div class="td_data_outer">
                            <div class="td_data">{{ v[0].job_address_full }}</div>
                          </div>
                        </td>
                        <td class="loc_location_total">
                          <div class="td_data_outer">
                            <div class="td_data">TOTALS:</div>
                          </div>
                        </td>
                        <td v-for="d in week">
                          <div class="td_data_outer">
                            <div class="td_data">{{ calc_location_day_totals(loc, d) }}<br>{{ calc_location_day_price_totals(loc, d) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_units_total(loc) }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_tbad(loc) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_pre_add_total(loc) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_post_add_total(loc) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_pre_ded_total(loc) | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_post_ded_total(loc) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_invoice_total(loc) | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      <tr class="worker_row" v-for="w in per_location[loc]">
                        <td class="firstName">
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.assignment.worker.person.first_name }} {{ w.assignment.worker.person.surname }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.order_job.rel_order_position.job_title }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.assignment.position_rate.rate_type }}/{{ w.assignment.position_rate.pay_type }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ w.assignment.position_rate.pay_amount | currency }}</div>
                          </div>
                        </td>
                        <td v-for="dayPay in w.timesheet_pay">
                          <div class="td_data_outer">
                            <div class="td_data">{{ dayPay.price }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ w.total_hours }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ w.total_price | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_pre_add(w.timesheet_additions_deductions) | currency}}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left" style="font-size: 0.65rem;"><span v-html="calc_location_pre_add_desc(w.timesheet_additions_deductions)"></span></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_post_add(w.timesheet_additions_deductions) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left" style="font-size: 0.65rem;"><span v-html="calc_location_post_add_desc(w.timesheet_additions_deductions)"></span></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_pre_ded(w.timesheet_additions_deductions) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left" style="font-size: 0.65rem;"><span v-html="calc_location_pre_ded_desc(w.timesheet_additions_deductions)"></span></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ calc_location_post_ded(w.timesheet_additions_deductions) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-left" style="font-size: 0.65rem;"><span v-html="calc_location_post_ded_desc(w.timesheet_additions_deductions)"></span></div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data text-center">{{ w.total_pay_amount | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot>
                      <tr>
                        <td class="running_totals" colspan="4">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">TOTALS</div>
                          </div>
                        </td>
                        <td v-for="d in week">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold">{{ parseFloat(calc_location_day_full_total(d)).toFixed(2) }}
                              <br>{{ calc_location_day_full_total_price(d) | currency }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_total_units_full_total() }}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_tbad_full_total() | currency }}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_total_pre_add() | currency}}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_total_post_add() | currency}}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_total_pre_ded() | currency}}</div>
                          </div>
                        </td>
                        <td colspan="2">
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_total_post_ded() | currency}}</div>
                          </div>
                        </td>
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data font-weight-bold text-center">{{ calc_location_invoice_full_total() | currency }}</div>
                          </div>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                <div class="col-12" v-if="selected_btn.works_completed">
                  <div class="row">
                    <div class="col-10 offset-1 form-group">
                      <button class="w-100 orcaBtn" :disabled="btn_download_works_completed" @click.prevent="download_works_completed"
                              :class="[btn_download_works_completed ? 'disabled' : '']">
                        <span v-if="btn_download_works_completed" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>DOWNLOADING EXCEL COPY - WORKS COMPLETED ..
                          .</span>
                        <span v-else>DOWNLOAD EXCEL COPY - WORKS COMPLETED</span>
                      </button>
                    </div>
                  </div>
                  <div class="table-responsive mb-3" id="historic_works_completed_table">
                    <table class="table table-striped table-sm">
                      <thead>
                      <tr>
                        <th></th>
                        <th colspan="7" class="text-center">WORKS COMPLETED</th>
                      </tr>
                      <tr>
                        <th scope="col" class="firstName">Job Title</th>
                        <th scope="col" class="wc_completed" v-for="d in week">
                          {{ d }}
                        </th>
                      </tr>
                      </thead>
                      <tbody v-for="(v, loc, i) in timesheets.locations" class="loc_body">
                      <tr class="header" @click="test($event)">
                        <td colspan="8" class="loc_location">
                          <div class="td_data_outer">
                            <div class="td_data">{{ loc }}</div>
                          </div>
                        </td>
                      </tr>
                      <tr class="worker_row" v-for="(wc, j) in works_completed[loc]">
                        <td>
                          <div class="td_data_outer">
                            <div class="td_data">{{ j }}</div>
                          </div>
                        </td>
                        <td v-for="c in wc" class="wc_completed">
                          <div class="td_data_outer">
                            <div class="td_data">{{ c.day_desc }}</div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader";
import timesheet_loader from "loaders/order_loader";
import Multiselect from 'vue-multiselect';

export default {
  name: "c_timesheet_live",
  components: {
    loadingCube,
    timesheet_loader,
    Multiselect
  },
  data() {
    return {
      loaded: false,
      ts_loading: false,

      ms_opts: {
        timesheet_period: []
      },
      company_id: null,
      timesheet_period: {
        for_work_end_week_date: null
      },
      timesheets: null,

      selected_btn: {
        per_worker_day: false,
        per_worker_loc: false,
        per_location: false,
        works_completed: false,
      },
      btn_download_worker_per_day: false,
      per_worker_day: [],
      btn_download_worker_per_location: false,
      per_worker_loc: [],
      week: {},
      btn_download_per_location: false,
      per_location: {},
      btn_download_works_completed: false,
      works_completed: {}
    }
  },
  beforeMount() {
    this.get_historic_timesheet_periods().then(() => {
      this.historic_ts_multiselect_form().then(() => this.loaded = true)
    })
  },
  methods: {
    test(event) {
      $(event.target.closest(".loc_body")).toggleClass('test')
    },
    get_historic_timesheet_periods() {
      return new Promise(resolve => {
        axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
          this.company_id = company.data.id;
          axios.get(this.crmApiPath + 'timesheet/current/get_live_period/' + company.data.id).then(ts_periods => {
            // this.ms_opts.timesheet_period = ts_periods.data;
            // console.log(ts_periods.data.for_work_end_week_date)
            this.timesheet_period.for_work_end_week_date = ts_periods.data.for_work_end_week_date;
            resolve();
          })
        });
      });
    },
    timesheet_period_label({for_work_end_week_date}) {
      return this.$options.filters.format_ts_period_date(for_work_end_week_date)
    },
    historic_ts_multiselect_form() {
      return new Promise(resolve => {
        this.ts_loading = true;
        this.timesheets = null;
        axios.get(this.crmApiPath + 'timesheet/historic/get_period', {
          params: {
            for_work_end_week_date: this.timesheet_period.for_work_end_week_date,
            company_id: this.company_id
          }
        }).then(historic_ts => {
          this.timesheets = historic_ts.data
          this.ts_loading = false;
          resolve();
        })
      })

    },
    format_selected_period(period) {
      return this.$options.filters.format_ts_period_date(period)
    },
    select_per_worker_day() {
      this.selected_btn = {
        per_worker_day: true,
        per_worker_loc: false,
        per_location: false,
        works_completed: false
      }
      this.get_week()
      this.calc_per_worker_day();
    },
    select_per_worker_loc() {
      this.selected_btn = {
        per_worker_day: false,
        per_worker_loc: true,
        per_location: false,
        works_completed: false
      }
      this.calc_per_worker_loc();
    },
    select_per_location() {
      this.selected_btn = {
        per_worker_day: false,
        per_worker_loc: false,
        per_location: true,
        works_completed: false
      }
      this.get_week()
      this.calc_per_location()
    },
    select_works_completed() {
      this.selected_btn = {
        per_worker_day: false,
        per_worker_loc: false,
        per_location: false,
        works_completed: true
      }
      this.get_week()
      this.calc_works_completed()
    },

    zindexcalc(index) {
      return 80 - index;
    },

    // ------------------------------------------------------------------------------
    // ------------------------------------------------ PER WORKER DAY
    calc_per_worker_day() {
      return new Promise(resolve => {
        this.per_worker_day = [];
        if (this.timesheets !== null) {
          // make initial array of per worker day
          for (let i = 0; i < this.timesheets.ts_records.length; i++) {
            if (!this.per_worker_day.some(e => e.worker_id === this.timesheets.ts_records[i].worker_id)) {
              this.per_worker_day.push({
                'worker_id': this.timesheets.ts_records[i].worker_id,
                'first_name': this.timesheets.ts_records[i].assignment.worker.person.first_name,
                'surname': this.timesheets.ts_records[i].assignment.worker.person.surname,
                'internal_finance_ref': this.timesheets.ts_records[i].assignment.worker.internal_finance_ref,
                'job_title': null,
                'pay_type': null,
                'rate_type': null,
                'pay_rate': null,
                [this.timesheets.ts_records[i].order_job_id]: {
                  'addition_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
                  'addition_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
                  'deduction_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
                  'deduction_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
                  'timesheet_pay': this.timesheets.ts_records[i].timesheet_pay,
                  'total_units': this.timesheets.ts_records[i].total_hours,
                  'total_before_additions_deductions': this.timesheets.ts_records[i].total_price,
                  'invoice_total': this.timesheets.ts_records[i].total_pay_amount,
                  //
                  'job_title': this.timesheets.ts_records[i].order_job.rel_order_position.job_title,
                  'pay_type': this.timesheets.ts_records[i].assignment.position_rate.pay_type,
                  'rate_type': this.timesheets.ts_records[i].assignment.position_rate.rate_type,
                  'pay_rate': this.timesheets.ts_records[i].assignment.position_rate.pay_amount,
                  'location': this.timesheets.ts_records[i].order_job.rel_order_location.job_address_full,
                }
              });
            }
            else {
              let existing = this.per_worker_day.find(r => r.worker_id === this.timesheets.ts_records[i].worker_id);
              existing[this.timesheets.ts_records[i].order_job_id] = {
                'addition_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
                'addition_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
                'deduction_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
                'deduction_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
                'timesheet_pay': this.timesheets.ts_records[i].timesheet_pay,
                'total_units': this.timesheets.ts_records[i].total_hours,
                'total_before_additions_deductions': this.timesheets.ts_records[i].total_price,
                'invoice_total': this.timesheets.ts_records[i].total_pay_amount,
                //
                'job_title': this.timesheets.ts_records[i].order_job.rel_order_position.job_title,
                'pay_type': this.timesheets.ts_records[i].assignment.position_rate.pay_type,
                'rate_type': this.timesheets.ts_records[i].assignment.position_rate.rate_type,
                'pay_rate': this.timesheets.ts_records[i].assignment.position_rate.pay_amount,
                'location': this.timesheets.ts_records[i].order_job.rel_order_location.job_address_full,
              }
            }
          }
          // loop per worker day array to check if job_title, pay type, rate type and pay rate are all the same
          for (let j = 0; j < this.per_worker_day.length; j++) {
            for (let key in this.per_worker_day[j]) {
              if (key !== 'first_name' && key !== 'internal_finance_ref'
                  && key !== 'surname' && key !== 'worker_id'
                  && key !== 'job_title' && key !== 'pay_type'
                  && key !== 'rate_type' && key !== 'pay_rate') {
                // job title
                if (this.per_worker_day[j].job_title === null) {
                  this.per_worker_day[j].job_title = this.per_worker_day[j][key].job_title;
                }
                else if (this.per_worker_day[j].job_title !== this.per_worker_day[j][key].job_title) {
                  this.per_worker_day[j].job_title = false;
                }
                // pay type
                if (this.per_worker_day[j].pay_type === null) {
                  this.per_worker_day[j].pay_type = this.per_worker_day[j][key].pay_type;
                }
                else if (this.per_worker_day[j].pay_type !== this.per_worker_day[j][key].pay_type) {
                  this.per_worker_day[j].pay_type = false;
                }
                // rate type
                if (this.per_worker_day[j].rate_type === null) {
                  this.per_worker_day[j].rate_type = this.per_worker_day[j][key].rate_type;
                }
                else if (this.per_worker_day[j].rate_type !== this.per_worker_day[j][key].rate_type) {
                  this.per_worker_day[j].rate_type = false;
                }
                // pay rate
                if (this.per_worker_day[j].pay_rate === null) {
                  this.per_worker_day[j].pay_rate = this.per_worker_day[j][key].pay_rate;
                }
                else if (this.per_worker_day[j].pay_rate !== this.per_worker_day[j][key].pay_rate) {
                  this.per_worker_day[j].pay_rate = false;
                }
              }
            }
          }
          // Sort per worker day array first by job title and then surname and then first_name
          this.per_worker_day.sort(function (a, b) {
            let surname_a = a.surname.toLowerCase(), surname_b = b.surname.toLowerCase(),
                first_name_a = a.first_name.toLowerCase(), first_name_b = b.first_name.toLowerCase();
            let job_title_a = '';
            if (a.job_title !== false) {
              job_title_a = a.job_title.toLowerCase()
            }
            let job_title_b = ''
            if (b.job_title !== false) {
              job_title_b = b.job_title.toLowerCase()
            }

            if (job_title_a < job_title_b) {
              return -1
            }
            if (job_title_a > job_title_b) {
              return 1
            }
            if (surname_a < surname_b) {
              return -1
            }
            if (surname_a > surname_b) {
              return 1
            }
            if (first_name_a < first_name_b) {
              return -1
            }
            if (first_name_a > first_name_b) {
              return 1
            }
          });
        }
        resolve();
      });
    },
    download_worker_per_day() {
      this.btn_download_worker_per_day = true;

      axios.post(this.crmApiPath + 'timesheet/download/per_worker_per_day', {
        'company_id': this.company_id,
        'week': this.week,
        'per_worker_per_day': this.per_worker_day,
        'pay_period': this.timesheet_period.for_work_end_week_date
      }, {
        responseType: 'arraybuffer'
      }).then(file_resp => {
        const url = window.URL.createObjectURL(new Blob([file_resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Per_Worker_Per_Day_period_ending_' + this.timesheet_period.for_work_end_week_date + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.btn_download_worker_per_day = false;
      })
    },

    get_worker_absence(worker, day_index){
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          if(worker[key].timesheet_pay[day_index].absence_type == "S"){
            return "Sick Day"
          } else if(worker[key].timesheet_pay[day_index].absence_type == "H") {
            return "Holiday"
          } else if(worker[key].timesheet_pay[day_index].absence_type == "M") {
            return "Miscellaneous"
          } else {
            return false; 
          }
        }
      }
    },

    calc_worker_day_total(worker, day_index) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          total += worker[key].timesheet_pay[day_index].price;
        }
      }
      return total;
    },
    calc_worker_day_price_total(worker, day_index) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          total += worker[key].timesheet_pay[day_index].price * worker[key].pay_rate;
        }
      }
      return total;
    },
    calc_worker_total_units(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          for (let i = 0; i < worker[key].timesheet_pay.length; i++) {
            total += worker[key].timesheet_pay[i].price;
          }
        }
      }
      return total;
    },
    calc_worker_total_b4_add_ded(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          total += worker[key].total_before_additions_deductions;
        }
      }
      return total;
    },

    calc_worker_total_pre_add(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          for (let i = 0; i < worker[key].addition_pre_tax.length; i++) {
            total += worker[key].addition_pre_tax[i].amount;
          }
        }
      }
      return total;
    },
    calc_worker_total_post_add(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          for (let i = 0; i < worker[key].addition_post_tax.length; i++) {
            total += worker[key].addition_post_tax[i].amount;
          }
        }
      }
      return total;
    },
    calc_worker_total_pre_ded(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          for (let i = 0; i < worker[key].deduction_pre_tax.length; i++) {
            total += worker[key].deduction_pre_tax[i].amount;
          }
        }
      }
      return total;
    },
    calc_worker_total_post_ded(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          for (let i = 0; i < worker[key].deduction_post_tax.length; i++) {
            total += worker[key].deduction_post_tax[i].amount;
          }
        }
      }
      return total;
    },

    calc_worker_total_invoice(worker) {
      let total = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
            && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
          total += worker[key].invoice_total;
        }
      }
      return total;
    },

    calc_worker_day_price(price, rate) {
      return price * rate;
    },

    calc_loc_pre_add(pre_tax) {
      let total = 0;
      for (let i = 0; i < pre_tax.length; i++) {
        total += pre_tax[i].amount
      }
      return total;
    },
    calc_loc_post_add(post_tax) {
      let total = 0;
      for (let i = 0; i < post_tax.length; i++) {
        total += post_tax[i].amount
      }
      return total;
    },
    calc_loc_pre_ded(pre_ded) {
      let total = 0;
      for (let i = 0; i < pre_ded.length; i++) {
        total += pre_ded[i].amount
      }
      return total;
    },
    calc_loc_post_ded(post_ded) {
      let total = 0;
      for (let i = 0; i < post_ded.length; i++) {
        total += post_ded[i].amount
      }
      return total;
    },

    calc_totals_worker_day(day_index) {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            total += this.per_worker_day[i][key].timesheet_pay[day_index].price;
          }
        }
      }
      return total;
    },
    calc_totals_worker_day_price(day_index) {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            total += (this.per_worker_day[i][key].timesheet_pay[day_index].price * this.per_worker_day[i][key].pay_rate);
          }
        }
      }
      return total;
    },
    calc_totals_worker_total_units() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            for (let j = 0; j < this.per_worker_day[i][key].timesheet_pay.length; j++) {
              total += this.per_worker_day[i][key].timesheet_pay[j].price;
            }
          }
        }
      }
      return total;
    },
    calc_totals_worker_total_b4_add_ded() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            total += this.per_worker_day[i][key].total_before_additions_deductions;
          }
        }
      }
      return total;
    },

    calc_totals_worker_pre_add() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            for (let j = 0; j < this.per_worker_day[i][key].addition_pre_tax.length; j++) {
              total += this.per_worker_day[i][key].addition_pre_tax[j].amount;
            }
          }
        }
      }
      return total;
    },
    calc_totals_worker_post_add() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            for (let j = 0; j < this.per_worker_day[i][key].addition_post_tax.length; j++) {
              total += this.per_worker_day[i][key].addition_post_tax[j].amount;
            }
          }
        }
      }
      return total;
    },
    calc_totals_worker_pre_ded() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            for (let j = 0; j < this.per_worker_day[i][key].deduction_pre_tax.length; j++) {
              total += this.per_worker_day[i][key].deduction_pre_tax[j].amount;
            }
          }
        }
      }
      return total;
    },
    calc_totals_worker_post_ded() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            for (let j = 0; j < this.per_worker_day[i][key].deduction_post_tax.length; j++) {
              total += this.per_worker_day[i][key].deduction_post_tax[j].amount;
            }
          }
        }
      }
      return total;
    },

    calc_totals_worker_total_invoice() {
      let total = 0;
      for (let i = 0; i < this.per_worker_day.length; i++) {
        for (let key in this.per_worker_day[i]) {
          if (key !== 'first_name' && key !== 'internal_finance_ref' && key !== 'job_title' && key !== 'pay_rate' && key !== 'pay_type'
              && key !== 'rate_type' && key !== 'surname' && key !== 'worker_id') {
            total += this.per_worker_day[i][key].invoice_total;
          }
        }
      }
      return total;
    },

    // ------------------------------------------------------------------------------
    // ------------------------------------------------ PER WORKER LOCATION
    calc_per_worker_loc() {
      return new Promise(resolve => {
        this.per_worker_loc = [];
        if (this.timesheets !== null) {
          for (let i = 0; i < this.timesheets.ts_records.length; i++) {
            if (!this.per_worker_loc.some(e => e.worker_id === this.timesheets.ts_records[i].worker_id)) {
              this.per_worker_loc.push({
                'worker_id': this.timesheets.ts_records[i].worker_id,
                'first_name': this.timesheets.ts_records[i].assignment.worker.person.first_name,
                'surname': this.timesheets.ts_records[i].assignment.worker.person.surname,
                'internal_finance_ref': this.timesheets.ts_records[i].assignment.worker.internal_finance_ref,
                'job_title': null,
                'pay_type': null,
                'rate_type': null,
                'pay_rate': null,
                [this.timesheets.ts_records[i].order_job_id]: {
                  'addition_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
                  'addition_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
                  'deduction_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
                  'deduction_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
                  'total_units': this.timesheets.ts_records[i].total_hours,
                  'total_before_additions_deductions': this.timesheets.ts_records[i].total_price,
                  'invoice_total': this.timesheets.ts_records[i].total_pay_amount,
                  'assignment': this.timesheets.ts_records[i].assignment,
                  //
                  'job_title': this.timesheets.ts_records[i].order_job.rel_order_position.job_title,
                  'pay_type': this.timesheets.ts_records[i].assignment.position_rate.pay_type,
                  'rate_type': this.timesheets.ts_records[i].assignment.position_rate.rate_type,
                  'pay_rate': this.timesheets.ts_records[i].assignment.position_rate.pay_amount,
                }
              });
            }
            else {
              let existing = this.per_worker_loc.find(r => r.worker_id === this.timesheets.ts_records[i].worker_id);
              existing[this.timesheets.ts_records[i].order_job_id] = {
                'addition_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 29),
                'addition_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 30),
                'deduction_pre_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 31),
                'deduction_post_tax': this.timesheets.ts_records[i].timesheet_additions_deductions.filter(tad => tad.add_ded_type_id === 32),
                'total_units': this.timesheets.ts_records[i].total_hours,
                'total_before_additions_deductions': this.timesheets.ts_records[i].total_price,
                'invoice_total': this.timesheets.ts_records[i].total_pay_amount,
                'assignment': this.timesheets.ts_records[i].assignment,
                //
                'job_title': this.timesheets.ts_records[i].order_job.rel_order_position.job_title,
                'pay_type': this.timesheets.ts_records[i].assignment.position_rate.pay_type,
                'rate_type': this.timesheets.ts_records[i].assignment.position_rate.rate_type,
                'pay_rate': this.timesheets.ts_records[i].assignment.position_rate.pay_amount,
              }
            }
          }
          // loop per worker day array to check if job_title, pay type, rate type and pay rate are all the same
          for (let j = 0; j < this.per_worker_loc.length; j++) {
            for (let key in this.per_worker_loc[j]) {
              if (key !== 'first_name' && key !== 'internal_finance_ref'
                  && key !== 'surname' && key !== 'worker_id'
                  && key !== 'job_title' && key !== 'pay_type'
                  && key !== 'rate_type' && key !== 'pay_rate') {
                // job title
                if (this.per_worker_loc[j].job_title === null) {
                  this.per_worker_loc[j].job_title = this.per_worker_loc[j][key].job_title;
                }
                else if (this.per_worker_loc[j].job_title !== this.per_worker_loc[j][key].job_title) {
                  this.per_worker_loc[j].job_title = false;
                }
                // pay type
                if (this.per_worker_loc[j].pay_type === null) {
                  this.per_worker_loc[j].pay_type = this.per_worker_loc[j][key].pay_type;
                }
                else if (this.per_worker_loc[j].pay_type !== this.per_worker_loc[j][key].pay_type) {
                  this.per_worker_loc[j].pay_type = false;
                }
                // rate type
                if (this.per_worker_loc[j].rate_type === null) {
                  this.per_worker_loc[j].rate_type = this.per_worker_loc[j][key].rate_type;
                }
                else if (this.per_worker_loc[j].rate_type !== this.per_worker_loc[j][key].rate_type) {
                  this.per_worker_loc[j].rate_type = false;
                }
                // pay rate
                if (this.per_worker_loc[j].pay_rate === null) {
                  this.per_worker_loc[j].pay_rate = this.per_worker_loc[j][key].pay_rate;
                }
                else if (this.per_worker_loc[j].pay_rate !== this.per_worker_loc[j][key].pay_rate) {
                  this.per_worker_loc[j].pay_rate = false;
                }
              }
            }
          }
          // Sort per_per worker array first by surname and then first_name
          this.per_worker_loc.sort(function (a, b) {
            let surname_a = a.surname.toLowerCase(), surname_b = b.surname.toLowerCase(),
                first_name_a = a.first_name.toLowerCase(), first_name_b = b.first_name.toLowerCase()
            if (surname_a < surname_b) {
              return -1
            }
            if (surname_a > surname_b) {
              return 1
            }
            if (first_name_a < first_name_b) {
              return -1
            }
            if (first_name_a > first_name_b) {
              return 1
            }
          });
        }
        resolve();
      });
    },
    download_per_worker_location() {
      this.btn_download_worker_per_location = true;

      axios.post(this.crmApiPath + 'timesheet/download/per_worker_per_location', {
        'locations': this.timesheets.locations,
        'per_worker_per_loc': this.per_worker_loc,
        'pay_period': this.timesheet_period.for_work_end_week_date
      }, {
        responseType: 'arraybuffer'
      }).then(file_resp => {
        const url = window.URL.createObjectURL(new Blob([file_resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Per_Worker_Per_Location_period_ending_' + this.timesheet_period.for_work_end_week_date + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.btn_download_worker_per_location = false;
      })
    },

    // per_worker_loc table rows (worker rows)
    get_worker_site_total(worker, loc) {
      let site_total = 0;
      for (let i = 0; i < this.timesheets.locations[loc].length; i++) {
        if (worker.hasOwnProperty(this.timesheets.locations[loc][i].order_job_id)) {
          site_total += worker[this.timesheets.locations[loc][i].order_job_id].total_before_additions_deductions
        }
      }
      return site_total;
    },
    calc_worker_pre_tax_addition(worker) {
      let addition_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' &&
            key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
          for (let i = 0; i < worker[key].addition_pre_tax.length; i++) {
            addition_pre_tax += worker[key].addition_pre_tax[i].amount;
          }
        }
      }
      return addition_pre_tax;
    },
    calc_worker_post_tax_addition(worker) {
      let addition_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' &&
            key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
          for (let i = 0; i < worker[key].addition_post_tax.length; i++) {
            addition_post_tax += worker[key].addition_post_tax[i].amount;
          }
        }
      }
      return addition_post_tax;
    },
    calc_worker_pre_tax_deduction(worker) {
      let deduction_pre_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' &&
            key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
          for (let i = 0; i < worker[key].deduction_pre_tax.length; i++) {
            deduction_pre_tax += worker[key].deduction_pre_tax[i].amount;
          }
        }
      }
      return deduction_pre_tax;
    },
    calc_worker_post_tax_deduction(worker) {
      let deduction_post_tax = 0;
      for (let key in worker) {
        if (key !== 'first_name' && key !== 'surname' && key !== 'worker_id' && key !== 'internal_finance_ref' &&
            key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
          for (let i = 0; i < worker[key].deduction_post_tax.length; i++) {
            deduction_post_tax += worker[key].deduction_post_tax[i].amount;
          }
        }
      }
      return deduction_post_tax;
    },
    get_worker_invoice_total(worker) {
      let invoice_total = 0;
      for (const [k, v] of Object.entries(this.timesheets.locations)) {
        for (let i = 0; i < v.length; i++) {
          if (worker.hasOwnProperty(v[i].order_job_id)) {
            invoice_total += worker[v[i].order_job_id].invoice_total
          }
        }
      }
      return invoice_total;
    },
    // per_worker_loc totals row
    calc_total_site_totals(loc) {
      let loc_order_job_ids = this.timesheets.locations[loc].map(value => value.order_job_id.toString());
      let site_total = 0;
      for (let j = 0; j < this.per_worker_loc.length; j++) {
        let worker_keys = Object.keys(this.per_worker_loc[j]);
        for (let k = 0; k < loc_order_job_ids.length; k++) {
          if (worker_keys.includes(loc_order_job_ids[k])) {
            site_total += this.per_worker_loc[j][loc_order_job_ids[k]].total_before_additions_deductions
          }
        }
      }
      return site_total;
    },
    calc_total_pre_tax_addition() {
      let pre_add_total = 0;
      for (let i = 0; i < this.per_worker_loc.length; i++) {
        for (let key in this.per_worker_loc[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'internal_finance_ref' && key !== 'worker_id' &&
              key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
            if (this.per_worker_loc[i][key].hasOwnProperty('addition_pre_tax')) {
              for (let k = 0; k < this.per_worker_loc[i][key].addition_pre_tax.length; k++) {
                pre_add_total += this.per_worker_loc[i][key].addition_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return pre_add_total;
    },
    calc_total_post_tax_addition() {
      let post_add_total = 0;
      for (let i = 0; i < this.per_worker_loc.length; i++) {
        for (let key in this.per_worker_loc[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'internal_finance_ref' && key !== 'worker_id' &&
              key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
            if (this.per_worker_loc[i][key].hasOwnProperty('addition_post_tax')) {
              for (let k = 0; k < this.per_worker_loc[i][key].addition_post_tax.length; k++) {
                post_add_total += this.per_worker_loc[i][key].addition_post_tax[k].amount;
              }
            }
          }
        }
      }
      return post_add_total;
    },
    calc_total_pre_tax_deduction() {
      let pre_ded_total = 0;
      for (let i = 0; i < this.per_worker_loc.length; i++) {
        for (let key in this.per_worker_loc[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'internal_finance_ref' && key !== 'worker_id' &&
              key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
            if (this.per_worker_loc[i][key].hasOwnProperty('deduction_pre_tax')) {
              for (let k = 0; k < this.per_worker_loc[i][key].deduction_pre_tax.length; k++) {
                pre_ded_total += this.per_worker_loc[i][key].deduction_pre_tax[k].amount;
              }
            }
          }
        }
      }
      return pre_ded_total;
    },
    calc_total_post_tax_deduction() {
      let post_ded_total = 0;
      for (let i = 0; i < this.per_worker_loc.length; i++) {
        for (let key in this.per_worker_loc[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'internal_finance_ref' && key !== 'worker_id' &&
              key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
            if (this.per_worker_loc[i][key].hasOwnProperty('deduction_post_tax')) {
              for (let k = 0; k < this.per_worker_loc[i][key].deduction_post_tax.length; k++) {
                post_ded_total += this.per_worker_loc[i][key].deduction_post_tax[k].amount;
              }
            }
          }
        }
      }
      return post_ded_total;
    },
    calc_total_invoice_total() {
      let total_invoice_total = 0;
      for (let i = 0; i < this.per_worker_loc.length; i++) {
        for (let key in this.per_worker_loc[i]) {
          if (key !== 'first_name' && key !== 'surname' && key !== 'internal_finance_ref' && key !== 'worker_id' &&
              key !== 'job_title' && key !== 'pay_type' && key !== 'rate_type' && key !== 'pay_rate') {
            total_invoice_total += this.per_worker_loc[i][key].invoice_total;
          }
        }
      }
      return total_invoice_total;
    },

    // ------------------------------------------------------------------------------
    // ------------------------------------------------ PER LOCATION
    get_week() {
      for (let j = 0; this.timesheets.ts_records.length; j++) {
        if (Object.keys(this.timesheets.ts_records[j]).length > 0) {
          for (let i = 0; i < this.timesheets.ts_records[0].timesheet_pay.length; i++) {
            this.week[i] = this.$moment.utc(this.timesheets.ts_records[0].timesheet_pay[i].pay_date).format('dddd DD/MM/YYYY')
          }
          break;
        }
      }
    },
    calc_per_location() {
      return new Promise(resolve => {
        let temp = {};
        if (this.timesheets !== null) {
          for (const [k, v] of Object.entries(this.timesheets.locations)) {
            let loc_order_job_ids = v.map(value => value.order_job_id.toString());
            temp[k] = [];
            for (let i = 0; i < this.timesheets.ts_records.length; i++) {
              if (loc_order_job_ids.includes(this.timesheets.ts_records[i].order_job_id.toString())) {
                temp[k].push(this.timesheets.ts_records[i])
              }
            }
            // Sort per_per worker array first by surname and then first_name
            temp[k].sort(function (a, b) {
              let surname_a = a.assignment.worker.person.surname.toLowerCase(), surname_b = b.assignment.worker.person.surname.toLowerCase(),
                  first_name_a = a.assignment.worker.person.first_name.toLowerCase(), first_name_b = b.assignment.worker.person.first_name.toLowerCase()
              if (surname_a < surname_b) {
                return -1
              }
              if (surname_a > surname_b) {
                return 1
              }
              if (first_name_a < first_name_b) {
                return -1
              }
              if (first_name_a > first_name_b) {
                return 1
              }
            });
            this.per_location[k] = temp[k]
          }
        }
        this.per_location = temp
        resolve();
      });
    },
    download_per_location() {
      this.btn_download_per_location = true;
      axios.post(this.crmApiPath + 'timesheet/download/per_location', {
        'week': this.week,
        'per_loc': this.per_location,
        'company_id': this.company_id,
        'pay_period': this.timesheet_period.for_work_end_week_date
      }, {
        responseType: 'arraybuffer'
      }).then(file_resp => {
        const url = window.URL.createObjectURL(new Blob([file_resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Per_Location_period_ending_' + this.timesheet_period.for_work_end_week_date + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.btn_download_per_location = false;
      })
    },

    calc_location_pre_add(add_ded) {
      if (add_ded.length > 0) {
        let total = 0;
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 29)
        for (let i = 0; i < ad.length; i++) {
          total += ad[i].amount;
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_pre_add_desc(add_ded) {
      if (add_ded.length > 0) {
        let total = '';
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 29)
        for (let i = 0; i < ad.length; i++) {
          total += this.$options.filters.currency(ad[i].amount) + ' ' + ad[i].add_ded_desc.value;
          if (i !== ad.length) {
            total += '<br>';
          }
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_post_add(add_ded) {
      if (add_ded.length > 0) {
        let total = 0;
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 30)
        for (let i = 0; i < ad.length; i++) {
          total += ad[i].amount;
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_post_add_desc(add_ded) {
      if (add_ded.length > 0) {
        let total = '';
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 30)
        for (let i = 0; i < ad.length; i++) {
          total += this.$options.filters.currency(ad[i].amount) + ' ' + ad[i].add_ded_desc.value;
          if (i !== ad.length) {
            total += '<br>';
          }
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_pre_ded(add_ded) {
      if (add_ded.length > 0) {
        let total = 0;
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 31)
        for (let i = 0; i < ad.length; i++) {
          total += ad[i].amount;
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_pre_ded_desc(add_ded) {
      if (add_ded.length > 0) {
        let total = '';
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 31)
        for (let i = 0; i < ad.length; i++) {
          total += this.$options.filters.currency(ad[i].amount) + ' ' + ad[i].add_ded_desc.value;
          if (i !== ad.length) {
            total += '<br>';
          }
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_post_ded(add_ded) {
      if (add_ded.length > 0) {
        let total = 0;
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 32)
        for (let i = 0; i < ad.length; i++) {
          total += ad[i].amount;
        }
        return total;
      }
      else {
        return '-';
      }
    },
    calc_location_post_ded_desc(add_ded) {
      if (add_ded.length > 0) {
        let total = '';
        let ad = add_ded.filter(tad => tad.add_ded_type_id === 32)
        for (let i = 0; i < ad.length; i++) {
          total += this.$options.filters.currency(ad[i].amount) + ' ' + ad[i].add_ded_desc.value;
          if (i !== ad.length) {
            total += '<br>';
          }
        }
        return total;
      }
      else {
        return '-';
      }
    },

    calc_location_day_totals(loc, d) {
      let date = this.$moment.utc(d.split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      let day_total = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        let pay_obj = this.per_location[loc][i].timesheet_pay.filter(tp => tp.pay_date === date)[0]
        day_total += pay_obj.price
      }
      return day_total;
    },
    calc_location_day_price_totals(loc, d) {
      let date = this.$moment.utc(d.split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      let day_total = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        let pay_obj = this.per_location[loc][i].timesheet_pay.filter(tp => tp.pay_date === date)[0]
        day_total += pay_obj.price * this.per_location[loc][i]['assignment']['position_rate']['pay_amount'];
      }
      return day_total;
    },
    calc_location_units_total(loc) {
      let unit_totals = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        unit_totals += this.per_location[loc][i].total_hours
      }
      return unit_totals;
    },
    calc_location_tbad(loc) {
      let tbad_totals = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        tbad_totals += this.per_location[loc][i].total_price
      }
      return tbad_totals;
    },

    calc_location_pre_add_total(loc) {
      let pre_add = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        for (let j = 0; j < this.per_location[loc][i].timesheet_additions_deductions.length; j++) {
          if (this.per_location[loc][i].timesheet_additions_deductions[j].add_ded_type_id === 29) {
            pre_add += this.per_location[loc][i].timesheet_additions_deductions[j].amount
          }
        }
      }
      return pre_add;
    },
    calc_location_post_add_total(loc) {
      let post_add = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        for (let j = 0; j < this.per_location[loc][i].timesheet_additions_deductions.length; j++) {
          if (this.per_location[loc][i].timesheet_additions_deductions[j].add_ded_type_id === 30) {
            post_add += this.per_location[loc][i].timesheet_additions_deductions[j].amount
          }
        }
      }
      return post_add;
    },
    calc_location_pre_ded_total(loc) {
      let pre_ded = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        for (let j = 0; j < this.per_location[loc][i].timesheet_additions_deductions.length; j++) {
          if (this.per_location[loc][i].timesheet_additions_deductions[j].add_ded_type_id === 31) {
            pre_ded += this.per_location[loc][i].timesheet_additions_deductions[j].amount
          }
        }
      }
      return pre_ded;
    },
    calc_location_post_ded_total(loc) {
      let post_ded = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        for (let j = 0; j < this.per_location[loc][i].timesheet_additions_deductions.length; j++) {
          if (this.per_location[loc][i].timesheet_additions_deductions[j].add_ded_type_id === 32) {
            post_ded += this.per_location[loc][i].timesheet_additions_deductions[j].amount
          }
        }
      }
      return post_ded;
    },

    calc_location_invoice_total(loc) {
      let invoice_totals = 0;
      for (let i = 0; i < this.per_location[loc].length; i++) {
        invoice_totals += this.per_location[loc][i].total_pay_amount
      }
      return invoice_totals;
    },

    calc_location_day_full_total(d) {
      let date = this.$moment.utc(d.split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      let day_total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          let pay_obj = value[i].timesheet_pay.filter(tp => tp.pay_date === date)[0]
          day_total += pay_obj.price
        }
      }
      return day_total;
    },
    calc_location_day_full_total_price(d) {
      let date = this.$moment.utc(d.split(' ')[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
      let day_total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          let pay_obj = value[i].timesheet_pay.filter(tp => tp.pay_date === date)[0]
          day_total += pay_obj.price * value[i].assignment.position_rate.pay_amount
        }
      }
      return day_total;
    },
    calc_location_total_units_full_total() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          total += value[i].total_hours
        }
      }
      return total;
    },
    calc_location_tbad_full_total() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          total += value[i].total_price
        }
      }
      return total;
    },

    calc_location_total_pre_add() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          for (let j = 0; j < value[i].timesheet_additions_deductions.length; j++) {
            if (value[i].timesheet_additions_deductions[j].add_ded_type_id === 29) {
              total += value[i].timesheet_additions_deductions[j].amount
            }
          }
        }
      }
      return total;
    },
    calc_location_total_post_add() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          for (let j = 0; j < value[i].timesheet_additions_deductions.length; j++) {
            if (value[i].timesheet_additions_deductions[j].add_ded_type_id === 30) {
              total += value[i].timesheet_additions_deductions[j].amount
            }
          }
        }
      }
      return total;
    },
    calc_location_total_pre_ded() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          for (let j = 0; j < value[i].timesheet_additions_deductions.length; j++) {
            if (value[i].timesheet_additions_deductions[j].add_ded_type_id === 31) {
              total += value[i].timesheet_additions_deductions[j].amount
            }
          }
        }
      }
      return total;
    },
    calc_location_total_post_ded() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          for (let j = 0; j < value[i].timesheet_additions_deductions.length; j++) {
            if (value[i].timesheet_additions_deductions[j].add_ded_type_id === 32) {
              total += value[i].timesheet_additions_deductions[j].amount
            }
          }
        }
      }
      return total;
    },

    calc_location_invoice_full_total() {
      let total = 0;
      for (const [key, value] of Object.entries(this.per_location)) {
        for (let i = 0; i < value.length; i++) {
          total += value[i].total_pay_amount
        }
      }
      return total;
    },

    // ------------------------------------------------------------------------------
    // ------------------------------------------------ WORKS COMPLETED
    calc_works_completed() {
      return new Promise(resolve => {
        let temp = [];
        for (const [k, v] of Object.entries(this.timesheets.locations)) {
          temp[k] = {};
          for (let i = 0; i < v.length; i++) {
            for (let j = 0; j < this.timesheets.orders.length; j++) {
              if (v[i].id === this.timesheets.orders[j].rel_order_location.id) {
                let tt = this.timesheets.orders[j].rel_order_position.job_title;
                temp[k][tt] = this.timesheets.orders[j].timesheet_info;
              }
            }
          }
          this.works_completed[k] = temp[k];
        }
        resolve();
      })
    },
    download_works_completed() {
      this.btn_download_works_completed = true;
      axios.post(this.crmApiPath + 'timesheet/download/works_completed', {
        'week': this.week,
        'locations': this.timesheets.locations,
        'works_completed': this.works_completed,
        'pay_period': this.timesheet_period.for_work_end_week_date
      }, {
        responseType: 'arraybuffer'
      }).then(file_resp => {
        const url = window.URL.createObjectURL(new Blob([file_resp.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Works_Completed_period_ending_' + this.timesheet_period.for_work_end_week_date + '.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.btn_download_works_completed = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sm-btn {
  width:       100%;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}

.ts_view_btns {
  .activeBtn {
    background-color: $green;
    border-color:     $green;
  }
}

.preview_sites {
  height:         170px;
  white-space:    nowrap;
  vertical-align: inherit;
}

.preview_sites > div {
  transform: translate(0, 50px) rotate(270deg);
  width:     65px;
}

.preview_sites > div > span {
  font-size:   0.75rem;
  padding:     0 5px;
  width:       165px;
  display:     block;
  white-space: normal;
  line-height: 12px;
}

.preview_site_totals, .add_ded_total_columns {
  text-align: center;
}

th.add_ded_total_columns {
  z-index:   80;
  min-width: 150px;
}

#historic_per_worker_day_table, #historic_per_worker_loc_table, #historic_per_location_table, #historic_works_completed_table {
  height:     auto;
  max-height: 650px;
  overflow-y: auto;

  td {
    position:    relative;
    height:      45px;
    line-height: 15px;
    padding:     0 0.3rem;

    .td_data_outer {
      height:   45px;
      display:  block;
      width:    100%;
      position: relative;
    }

    .td_data {
      position:  absolute;
      top:       50%;
      transform: translateY(-50%);
      width:     100%;
    }

    &.firstName {
      z-index: 81;
    }

    &.running_totals {
      z-index: 101;
    }

    &.days, &.additionsDesc, &.deductionsDesc {
      padding: 0;
    }

    &.releaseRetention, &.backNextWeek {
      font-size: 1.25rem;
      /*z-index:   27;*/
    }

    &.submitPayroll {
      font-size: 1.25rem;
    }
  }

  .firstName {
    min-width: 150px;
    position:  sticky;
    left:      0;
    z-index:   85;
    //background-color: rgba(lighten($bc_4, 35%), 1);
  }

  tfoot {
    position:   -webkit-sticky;
    position:   sticky;
    bottom:     0;
    left:       0;
    background: #666;
    z-index:    99;

    tr, td {
      position:   -webkit-sticky;
      position:   sticky;
      bottom:     0;
      left:       0;
      background: $white;
      z-index:    99;
    }

    td {
      padding: 0;
    }

    td > div {
      padding:       0 0.3rem;
      border-color:  darken($bc_1, 10%);
      border-width:  6px;
      border-style:  double;
      border-left:   none;
      border-right:  none;
      border-bottom: none;
      margin-bottom: 10px;
    }
  }
}

#historic_per_worker_day_table {
  .firstName {
    min-width: 310px;
  }
}

#historic_works_completed_table {
  .wc_completed {
    min-width: 200px;
    max-width: 300px;
  }
}

#historic_per_worker_day_table, #historic_per_location_table {
  .days {
    max-width: 1300px;
  }

  .days > div {
    transform: translate(-2px, 22px) rotate(285deg);
    width:     120px;
  }

  .jobTitle {
    max-width: 110px;
    min-width: 110px;
    left:      inherit;
    position:  sticky;
  }
}

#historic_per_location_table {
  .days > div {
    transform: translate(-40px, 22px) rotate(285deg);
  }
}

.loc_body {
  border-bottom: 2px solid black;

  .header {
    &:hover {
      td {
        background-color: $bc_1 !important;
        cursor:           pointer;
      }
    }

    td {
      background-color: lighten($bc_1, 30%) !important;
    }

    .loc_location {
      min-width: 300px;
      position:  sticky !important;
      left:      0;
      z-index:   29;
    }

    .loc_location_total {
      min-width: 110px;
      position:  sticky !important;
      left:      370px;
      z-index:   29;
    }
  }

  .worker_row {
    display: none;
  }

  &.test {
    .header {
      td {
        background-color: $bc_1 !important;
      }
    }

    .worker_row {
      display: table-row;
    }
  }
}

</style>
